export const UnitsView = {
	Certificate: 'Certificado',
	'Loading...': 'Cargando...',
	'You can download your completion certificate.':
		'Puedes descargar tu certificado de aprobación.',
	'You cannot download your completion certificate.':
		'No puedes descargar tu certificado de aprobación.',
	'You failed': 'Reprobaste',
	'Error getting the verification link':
		'Error al obtener el enlace de verificación',
	'Approved details.':
		'Para finalizar tu curso y obtener tu certificado haz clic en el botón "Finaliza tu curso".',
	'Unit list': 'Listado de módulos',
	'Finish your course': 'Finaliza tu curso',
	'Course of': 'Curso de "{{course}}"',
	'Complete your course': 'Completa tu curso',
	'Closing course...': 'Cerrando tu curso...',
	'Download certificate': 'Descargar certificado',
	'Downloading...': 'Descargando...',
	'Not reach the grade needed':
		'No alcanzaste la nota que se necesita para aprobar el curso, puedes comunicarte con nuestro equipo de soporte para revisar tu situación.',
	'Remaining attempts title': 'Aún tienes intentos disponibles',
	'Remaining attempts intro':
		'Te quedan intentos en las siguientes pruebas. Puedes volver a rendirlas para mejorar tu nota antes de finalizar el curso:',
	'Finish anyway': 'Finalizar de todas formas',
	'Go back': 'Volver',
	unlimited_attempts: 'intentos ilimitados',
	'unlimited attempts': 'intentos ilimitados',
	attempts_left_one: '{{count}} intento restante',
	attempts_left_other: '{{count}} intentos restantes',
	'attempts left_one': '{{count}} intento restante',
	'attempts left_other': '{{count}} intentos restantes',
};
